var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-entry"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('br'),_vm._v(" "),_c('button',{class:{
			'icon-upload': true,
			svg: true,
			'loading-small': _vm.uploading,
		},attrs:{"id":"uploadlogo","disabled":_vm.uploading,"title":_vm.buttonTitle},on:{"click":_vm.onUploadClick}}),_vm._v(" "),(_vm.hint !== '')?_c('em',[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),_c('input',{ref:"fileInput",staticClass:"hidden-visually",attrs:{"id":_vm.id,"type":"file","aria-hidden":"true","accept":_vm.acceptedMimeTypes},on:{"change":function($event){return _vm.$emit('change', $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }